import { applyMiddleware, createStore } from "redux";
import { appReducer } from "./app.reducer";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";

const composeEnhancers = composeWithDevTools({});

export const store = createStore(appReducer, composeEnhancers(applyMiddleware(thunk)));
